<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData"
            :pagination="false" :loading="tloading" rowKey="id"  @change="handleTableChange">
            <template slot="operation" slot-scope="text, record">
                <!-- <a class="tableLink"  href="javascript:;" @click="handleAuthPassway(record)">渠道授权</a> -->
                <router-link class="tableLink" :to="{path:'detail_passway',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_passway',query: {id: record.id,}}">编辑</router-link>

                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
        </a-table>

        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

        <authE ref="autheEID"></authE>

    </div>
</template>
<script>
import authE from './auth'
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const columns = [
    // {
    //     title: "序号",
    //     width: 50,
    //     align: "center",
    //     customRender: (text, record, index) => {
    //         let { page, pageSize } = pagination;
    //         return (Number(page) - 1) * Number(pageSize) + index + 1;
    //     }
    // },
    {
        title: "通道编码",
        dataIndex: "passwaycode",
        align: 'center',
        width:120
    },
    {
        title: "通道名称",
        dataIndex: "passwayname",
        align: 'center',
        width:120
    },
    // {
    //     title: "通道类型",
    //     dataIndex: "passwaytype",
    //     width:100
    // },
    {
        title: "通道类型",
        dataIndex: "passwaytypename",
        align: 'center',
        width:200
    },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatetime",
    //     width:150
    // },
    // {
    //     title: "更新人",
    //     dataIndex: "updatetuser",
    //     width:150
    // },
    // {
    //     title: "创建人",
    //     dataIndex: "createuser",
    //     width:150
    // },
    // {
    //     title: "创建时间",
    //     dataIndex: "creattime",
    //     width:150
    // },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }

];




export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{},
        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/deletepassway",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },

        handleAuthPassway(record){
            //渠道授权
            this.$refs.autheEID.showModal({
                passwaycode:record.passwaycode,
                passwayname:record.passwayname,
                passwaytype:record.passwaytype
            });
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/querypasswaypage",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },

        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        }
    },
    components:{
        authE
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

